import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2xwpcfzm5: FaireProductEntity = {
  token: "p_s2xwpcfzm5",
  type: "product",
  name: "Selenite Orgonite Pyramids",
  brandToken: "b_eqykpyrhjx",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a7f0d5a2a01ddcd458622e42d4e4fa27c98b1c47d02f81456f43409fff3b2a89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9dfbe66f371e653c08652ecc973205eb14aaced7109a648ec852b1801437a579.jpeg",
    "https://cdn.faire.com/fastly/ab35e2b8d4715644b593a9a8aef8411b037498203b1e302761232e8de2808436.jpeg",
  ],
  priceDollars: 5,
  description:
    "You will receive 1 selenite orgonite pyramid.\n\nThe word orgonite comes from \"orgone\", the name given by Wilhelm Reich to vital energy found everywhere in nature. It is life energy, also called Ch'i, Prana, and Aether. This vital energy exists, in a natural way, under many different forms. Orgonite is a mixture of catalyzed fiberglass resin with metal shavings, particles or powders, poured into molds. It is said to attract aetheric energy similarly to Reich's accumulators.\n\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n*Each and every crystal shipped from us is blessed with Reiki Love.\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:26.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
